import { watchEffect } from 'vue'
import { gdpr } from './gdpr.js'
import { datadogRum } from '@datadog/browser-rum'
import { hasRole, jwt, roles } from './jwt.js'
import { features } from '@/store/features.js'

function getTrackingConsent() {
    return gdpr.analytics ? 'granted' : 'not-granted'
}

// build a version of the above that just discards anything sent to it
const discard = {
    init() {
        console.log('datadog:init', [...arguments])
    },
    setTrackingConsent() {
        console.log('datadog:setTrackingConsent', [...arguments])
    },
    startSessionReplayRecording() {
        console.log('datadog:startSessionReplayRecording', [...arguments])
    },
    setUser() {
        console.log('datadog:setUser', [...arguments])
    },
}

// discarding everything is the default mode of operation
const implementation = features.dataDogEnabled ? datadogRum : discard

// in the future, if desired, we could configure a bunch of stuff in
// features around how datadog should be configured and we could
// pass that additional state along; that would let us have
// per-environment sampling configurations, etc
implementation.init({
    applicationId: 'b0bdc85a-68c2-408d-b9f1-b3a792143d38',
    clientToken: 'pubb06b333dbbcd325e973edd7baf456aa6',
    site: 'datadoghq.com',
    service: 'managementtrack',
    env: features.environment,
    // Specify a version number to identify the deployed version of your application in Datadog
    // version: '1.0.0',
    sessionSampleRate: 100,
    sessionReplaySampleRate: 100,
    telemetrySampleRate: 0,
    trackUserInteractions: true,
    trackResources: true,
    trackLongTasks: true,
    defaultPrivacyLevel: 'mask-user-input',
    trackingConsent: getTrackingConsent(),
})

implementation.startSessionReplayRecording()

watchEffect(() => {
    implementation.setTrackingConsent(getTrackingConsent())
})

let lastId = 0

watchEffect(() => {
    const id = jwt.id ?? 0

    if (lastId !== id && id > 0) {
        implementation.setUser({
            id: jwt.id,
            name: jwt.name,
            email: jwt.username,
            subscribed: hasRole(roles.subscribed),
            organizationId: jwt.organizationId,
            organizationName: jwt.organizationName,
        })

        lastId = id
    }
})
